
import React from 'react';
import {
  MapPin, Star, Shield, Clock, Home, Sparkles, Calendar,
  Heart, Users, CheckCircle, Target, Zap, ArrowRight, FileText, Phone,
  type LucideIcon,
} from 'lucide-react';

const BADGE_ICON_MAP: Record<string, LucideIcon> = {
  MapPin, Star, Shield, Clock, Home, Sparkles, Calendar,
  Heart, Users, CheckCircle, Target, Zap, ArrowRight, FileText, Phone,
};

interface HeroSectionProps {
  label?: string;
  labelIcon?: string;
  title?: string;
  subtitle?: string;
  badges?: { label: string; icon?: string }[];
}

const DEFAULT_BADGES = [
  { label: 'Paulista · Mogi · Suzano', icon: 'MapPin' },
  { label: '5.0 no Google',            icon: 'Star' },
  { label: 'CRN/3-63492',              icon: 'Shield' },
];

export const HeroSection: React.FC<HeroSectionProps> = ({
  label = '3 Localizações em São Paulo',
  labelIcon = 'MapPin',
  title = 'Nossos Consultórios',
  subtitle = 'Atendimento de qualidade em locais estratégicos. Escolha o consultório mais próximo de você.',
  badges = DEFAULT_BADGES,
}) => {
  const LabelIcon = BADGE_ICON_MAP[labelIcon] ?? MapPin;
  return (
    <section className="bg-brand-primary py-14 sm:py-20">
      <div className="container mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 text-white/90 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-wide uppercase">
          <LabelIcon className="w-3.5 h-3.5" />
          {label}
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-primary mb-4 leading-tight">
          {title}
        </h1>
        <p className="text-white/75 text-base sm:text-lg max-w-2xl mx-auto font-primary">
          {subtitle}
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-4">
          {badges.map((b) => {
            const Icon = BADGE_ICON_MAP[b.icon ?? ''] ?? MapPin;
            return (
              <div key={b.label} className="flex items-center gap-2 bg-white/10 text-white text-sm font-medium px-4 py-2 rounded-full">
                <Icon className="w-4 h-4 text-white/70" />
                {b.label}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
